import React, { type ReactNode } from 'react';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	emptyStateBackgroundStyled: {
		position: 'relative',
		borderRadius: token('border.radius.200'),
		borderWidth: token('border.width'),
		borderColor: token('color.border'),
		borderStyle: 'solid',
		paddingTop: token('space.250'),
		paddingRight: token('space.400'),
		paddingBottom: token('space.250'),
		paddingLeft: token('space.400'),
	},
	image: {
		width: '180px',
		height: '170px',
	},
});
export interface EmptyStateProps {
	title: ReactNode;
	description?: ReactNode;
	image?: ReactNode;
	imageUrl?: string;
	actions?: ReactNode;
	testId?: string;
}

export const EmptyStateNew = (props: EmptyStateProps) => {
	const { title, description, imageUrl, actions, testId, image } = props;
	const img = imageUrl ? <Image src={imageUrl} alt="" /> : image;

	return (
		<Box
			backgroundColor="elevation.surface"
			xcss={styles.emptyStateBackgroundStyled}
			testId={testId}
		>
			<Inline space="space.400" alignBlock="center">
				<Box xcss={styles.image}>{img}</Box>
				<Stack space="space.200" alignBlock="center">
					<Heading size="small">{title}</Heading>
					<Text>{description}</Text>
					<Inline space="space.050">{actions}</Inline>
				</Stack>
			</Inline>
		</Box>
	);
};
